import dashboardsData from '../config/dashboards.json'
import type { Dashboard } from '../types'

interface DashboardConfig {
  id: string
  name: string
  description: string
  url?: string
  urlEnvVar?: string
  icon?: string
  category?: string
  roles?: string[]
}

const env = import.meta.env as Record<string, string | undefined>

const resolveDashboard = (dashboard: DashboardConfig): Dashboard => ({
  id: dashboard.id,
  name: dashboard.name,
  description: dashboard.description,
  url: dashboard.url?.trim() || (dashboard.urlEnvVar ? env[dashboard.urlEnvVar]?.trim() || '' : ''),
  icon: dashboard.icon,
  category: dashboard.category,
  roles: dashboard.roles,
})

export const getDashboards = (): Dashboard[] => {
  return (dashboardsData.dashboards as DashboardConfig[]).map(resolveDashboard)
}

export const getDashboardById = (id: string): Dashboard | undefined => {
  return getDashboards().find(dashboard => dashboard.id === id)
}

export const getDashboardsByCategory = (category: string): Dashboard[] => {
  return getDashboards().filter(
    dashboard => dashboard.category === category
  )
}
